if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.currentProduct = null;
      this.currentVariant = null;
      this.quantity = 1;
      this.init();
    }

    init() {
      this.initSwiper();
    }

        renderModalProductData(stitchingProductsJSON, product, currentVariant, isVariantCard = false) {
            this.isVariantCard = isVariantCard;
            this.currentProduct = product
            this.modalOverlay = document.querySelector("#modal-overlay")
            if (!this.currentProduct) return null
            const modalProductTitle = this.querySelector(".quick-add-modal__product-title")
            const modalProductPriceContainer = this.querySelector(".quick-add-modal__price-container")
            const modalProductPrice = this.querySelector(".quick-add-modal__price span")
            const modalProductCompareAtPrice = this.querySelector(".quick-add-modal__compare-at-price s")
            const modalProductSaleBadge = this.querySelector(".quick-add-modal__sale-badge")
            const productSizesWrapper = this.querySelector(".quick-add-modal__sizes")
            const productSizesContainer = this.querySelector(".quick-add-modal__sizes-grid")
            const stitchingProductsContainer = this.querySelector(".quick-add-modal__colors-grid")
            const stitchingProductsSelectedColor = this.querySelector(".quick-add-modal__colors-title .selected-color")
            const selectedColorName = this.currentProduct.title.split('-').at(-1)
            this.currentVariant = currentVariant
            this.reviewContainer = this.querySelector(".yotpo-widget-instance__quick-add-modal")
            this.wishlistButton = this.querySelector(".quick-add-modal__wishlist")
            this.productDetailsUrl = this.querySelector(".quick-add-modal__info-product-details a")


            if (this.reviewContainer){
                this.reviewContainer.setAttribute("data-yotpo-product-id", this.currentProduct.id)
                try {
                    window.yotpoWidgetsContainer?.initWidgets?.()
                } catch (e) {
                    console.debug('[QuickAddModal] Yotpo initWidgets error', e)
                }
            }

            if (this.wishlistButton){
                const parent = this.wishlistButton.parentElement;
                const newBtn = this.wishlistButton.cloneNode(false);
                newBtn.className = 'st-wishlist-button quick-add-modal__wishlist';
                newBtn.setAttribute("data-type", "details");
                newBtn.setAttribute("data-handle", this.currentProduct.handle);
                newBtn.setAttribute("data-id", this.currentProduct.id);
                newBtn.setAttribute("data-product-id", this.currentProduct.id);
                parent.replaceChild(newBtn, this.wishlistButton);
                this.wishlistButton = newBtn;
            }

            function waitForSWishlistMethods(callback, interval = 100, timeout = 5000) {
                const start = Date.now();
                const timer = setInterval(() => {
                    if (window.SWishlist && (typeof window.SWishlist.updateButtonsWatcher === 'function' || typeof window.SWishlist.pushToWatcher === 'function')) {
                        clearInterval(timer);
                        callback(window.SWishlist);
                    } else if (Date.now() - start > timeout) {
                        clearInterval(timer);
                    }
                }, interval);
            }

            this.onclick = (event) => {
                if (event.target === this) {
                    this.close()
                }
            }
            
            if (this.modalOverlay){
                this.modalOverlay.onclick = (event) => {
                    if (event.target === this.modalOverlay) {
                        this.close()
                    }
                }
            }

            if (stitchingProductsSelectedColor){
                stitchingProductsSelectedColor.textContent = selectedColorName
            }

            const { stitchingProductsData } = stitchingProductsJSON ? JSON.parse(stitchingProductsJSON?.innerHTML) || JSON.parse(stitchingProductsJSON) : {}

            if (modalProductTitle) {
                modalProductTitle.textContent = this.currentProduct.title
            }

            if (modalProductPrice) {
                modalProductPriceContainer.classList.remove("sale-price")
                modalProductPrice.textContent = this.formatMoney(currentVariant.price)
                modalProductSaleBadge.style.display = "none"
            }

            if (modalProductCompareAtPrice && currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
                modalProductPriceContainer.classList.add("sale-price")
                modalProductCompareAtPrice.textContent = this.formatMoney(currentVariant.compare_at_price)
                modalProductSaleBadge.style.display = "inline-flex"
                modalProductSaleBadge.textContent = Math.floor((currentVariant.compare_at_price - currentVariant.price) * 100 / currentVariant.compare_at_price) + "% off"
            } else if (!currentVariant.compare_at_price || currentVariant.compare_at_price <= currentVariant.price) {
                modalProductPriceContainer.classList.remove("sale-price")
                modalProductCompareAtPrice.textContent = ""
                modalProductSaleBadge.style.display = "none"
            }

            if (stitchingProductsData) {
                this.renderStitchingProducts(stitchingProductsContainer, stitchingProductsData, product)
            }

            if (isVariantCard) {
                // Variant is already pre-selected — no need to show the size picker
                productSizesWrapper.style.display = "none"
            } else if (productSizesContainer && this.currentProduct.options.includes("Size")) {
                productSizesWrapper.style.display = ""
                this.renderProductVariants(this.currentProduct, productSizesContainer, currentVariant)
            } else if (productSizesContainer && !this.currentProduct.options.includes("Size")) {
                productSizesWrapper.style.display = "none"
            }

            if(this.productDetailsUrl){
                this.productDetailsUrl.href = `/products/${this.currentProduct.handle}`
            }



            this.quickAddButton = this.querySelector(".quick-add-modal__add-to-cart")
            this.quickAddButtonPrice = this.querySelector(".quick-add-modal__add-to-cart .button__price")
            this.quantityValueContainer = this.querySelector(".quick-add-modal__quantity-value")
            this.decreaseButton = this.querySelector("[data-action='decrease']")
            this.increaseButton = this.querySelector("[data-action='increase']")
            this.decreaseButton.disabled = this.quantity <= 1
            this.removeListenersToButtons()
            this.addListenersToButton()
            this.updateGallery(product, currentVariant)

            if (this.addToCartHandler && this.quickAddButton) {
                this.quickAddButton.removeEventListener("click", this.addToCartHandler);
            }

            this.addToCartHandler = () => {
                this.addToCart().then();
            };

            if (this.currentVariant.available){
                this.quickAddButton.disabled = false
                this.quickAddButton?.addEventListener("click", this.addToCartHandler)
            }else{
                this.quickAddButton.disabled = true
            }

            this.updateButtonPrice(this.currentVariant, this.quantity)

            waitForSWishlistMethods((SWishlist) => {
                setTimeout(() => {
                    try {
                        SWishlist.pushToWatcher?.(document);
                    } catch (e) {
                        console.debug('SWishlist.pushToWatcher error', e);
                    }
                    try {
                        SWishlist.updateButtonsWatcher?.(document, true);
                    } catch (e) {
                        console.debug('SWishlist.updateButtonsWatcher error', e);
                    }
                }, 0);
            });
        }

        updateButtonPrice(variant, quantity){
            if (this.quickAddButtonPrice){
                this.quickAddButtonPrice.textContent = ` - ${this.formatMoney(variant.price * quantity)}`
            }
        }

        addListenersToButton(){
            this.removeListenersToButtons();
            this.increaseHandler = (event) => this.increaseQuantity(event);
            this.decreaseHandler = (event) => this.decreaseQuantity(event);

            this.increaseButton?.addEventListener("click", this.increaseHandler);
            this.decreaseButton?.addEventListener("click", this.decreaseHandler);
        }

        removeListenersToButtons(){
            if (this.increaseHandler && this.increaseButton) {
                this.increaseButton.removeEventListener("click", this.increaseHandler);
            }
            if (this.decreaseHandler && this.decreaseButton) {
                this.decreaseButton.removeEventListener("click", this.decreaseHandler);
            }
        }

        renderStitchingProducts(stitchingProductsContainer, stitchingProducts, product) {
            let stitchingProductsButtonsHTML = ``
            if (stitchingProducts.length) {
                stitchingProducts.forEach(item => {
                    const stitchingProduct = item.stitching_product
                    stitchingProductsButtonsHTML += `
                            <div class="quick-add-modal__colors-item ${stitchingProduct.id === product.id ? 'active': ''}" data-product='${JSON.stringify(stitchingProduct).replace(/'/g, "&apos;")}'>
                                <span class="quick-add-modal__colors-item-inner"><img src="${stitchingProduct.featured_image}" alt=""></span>
                            </div>
                        `
                })
                stitchingProductsContainer.innerHTML = stitchingProductsButtonsHTML
                const stitchingProductsButtons = stitchingProductsContainer.querySelectorAll(".quick-add-modal__colors-item")

                if (stitchingProductsButtons) {
                    stitchingProductsButtons.forEach(button => {
                        button.addEventListener("click", (event) => {
                            this.chooseColor(event, stitchingProducts)
                        })
                    })
                }
            }
        }

        renderProductVariants(product, container, currentVariant){
            let html =''
            if (product.variants.length > 1){
                const variants = product.variants
                // Используем только currentVariant как источник истины
                const activeVariantId = currentVariant?.id || this.currentVariant?.id
                variants.forEach(variant => {
                    html += `
                        <div class="quick-add-modal__sizes-item ${variant.id === activeVariantId ? 'active' : ''}" data-variant='${JSON.stringify(variant).replace(/'/g, "&apos;")}'>
                            ${variant.option2}
                        </div>
                    `
                })
                container.innerHTML = html
                const variantButtons = container.querySelectorAll(".quick-add-modal__sizes-item")
                if (variantButtons){
                    variantButtons.forEach(button => {
                        button.addEventListener("click", (event)=>{
                            this.chooseVariant(event)
                        })
                    })
                }

            }
        }

        chooseColor(event) {

            const selectedProductJSON = event.currentTarget.getAttribute("data-product")
            this.currentProduct = JSON.parse(selectedProductJSON)
            this.currentVariantJSON = document.querySelector(`[data-product-card-${this.currentProduct.id}]`).getAttribute("data-current-variant")
            this.currentVariant = JSON.parse(this.currentVariantJSON)
            const stitchingProductsJSON = document.querySelector(`[data-card-stitching-${this.currentProduct.id}]`)
            const stitchingProductsSelectedColor = this.querySelector(".quick-add-modal__colors-title .selected-color")
            const selectedColorName = this.currentProduct.title.split('-').at(-1)

            if (stitchingProductsSelectedColor){
                stitchingProductsSelectedColor.textContent = selectedColorName
            }

            this.quantity = 1;
            if (this.quantityValueContainer) {
                this.quantityValueContainer.textContent = this.quantity;
            }

            if (this.currentProduct) {
                this.renderModalProductData(stitchingProductsJSON, this.currentProduct, this.currentVariant)
            }

        }

        chooseVariant(event){
            const selectedVariantJSON = event.currentTarget.getAttribute("data-variant")
            this.currentVariant = JSON.parse(selectedVariantJSON)
            const variantButtons = this.querySelectorAll(".quick-add-modal__sizes-item")
            variantButtons.forEach(button => {
                button.classList.remove("active")
            })
            event.currentTarget.classList.add("active")
            this.updateButtonPrice(this.currentVariant, this.quantity)
        }

        updateQuantityButtonsState() {
            if (this.decreaseButton) {
                if (this.quantity <= 1) {
                    this.decreaseButton.setAttribute("disabled", "disabled");
                    this.decreaseButton.classList.add("disabled");
                } else {
                    this.decreaseButton.removeAttribute("disabled");
                    this.decreaseButton.classList.remove("disabled");
                }
            }
        }

        increaseQuantity(){
            this.quantity++
            this.quantityValueContainer.textContent = this.quantity
            this.updateQuantityButtonsState();
            this.updateButtonPrice(this.currentVariant, this.quantity)
        }

        decreaseQuantity(event){
            if (this.quantity > 1){
                this.quantity--
                this.quantityValueContainer.textContent = this.quantity
                this.updateQuantityButtonsState();
                this.updateButtonPrice(this.currentVariant, this.quantity)
            }
    }

    initSwiper() {
      const mainSwiper = this.querySelector('[data-gallery-main]');

      if (mainSwiper) {
        if (this.mainSwiper) {
          this.mainSwiper.destroy(true, true);
          this.mainSwiper = null;
        }

        if (typeof Swiper === 'undefined') {
          return;
        }

        this.mainSwiper = new Swiper(mainSwiper, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: false,
          navigation: {
            nextEl: mainSwiper.querySelector('[data-arrow-next]'),
            prevEl: mainSwiper.querySelector('[data-arrow-prev]'),
          },
          on: {
                        init: function () {

            }
          }
        });
      }
    }

        updateGallery(product, currentVariant) {
            if (!product) return null

      const mainSwiper = this.querySelector('[data-gallery-main] .swiper-wrapper');
      if (!mainSwiper) return;

      mainSwiper.innerHTML = '';

      if (this.isVariantCard) {
        // Variant layout: show only the variant's own image (or a placeholder)
        const variantImage = currentVariant && currentVariant.featured_image;
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';

        if (variantImage && variantImage.src) {
          slide.innerHTML = `
            <div class="quick-add-modal__gallery-slide-inner">
              <img src="${variantImage.src}" alt="${variantImage.alt || product.title}">
            </div>
          `;
        } else {
          const placeholderEl = document.getElementById('quick-add-modal-variant-placeholder');
          const placeholderHtml = placeholderEl ? placeholderEl.innerHTML : '';
          slide.innerHTML = `<div class="quick-add-modal__gallery-slide-inner">${placeholderHtml}</div>`;
        }

        mainSwiper.appendChild(slide);
      } else {
        // Regular product: show all product media
        product.media.forEach((media) => {
          const mainSlide = document.createElement('div');
          mainSlide.className = 'swiper-slide';

          if (media.media_type === 'image') {
            mainSlide.innerHTML = `
              <div class="quick-add-modal__gallery-slide-inner">
                <img
                    src="${media.preview_image.src}"
                    alt="${media.preview_image.alt || product.title}"
                >
              </div>
            `;
          } else if (media.media_type === 'video') {
            mainSlide.innerHTML = `
              <div class="quick-add-modal__gallery-slide-inner">
                <video
                    src="${media.sources[0].url}"
                    controls
                    style="width: 100%; height: 100%; object-fit: cover;"
                ></video>
              </div>
            `;
          }

          mainSwiper.appendChild(mainSlide);
        });
      }

      setTimeout(() => {
        this.initSwiper();
      }, 100);
    }

    async addToCart() {
        if (!this.currentVariant) {
        return;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: this.currentVariant.id,
            quantity: this.quantity
          })
        });

        if (response.ok) {
          this.close();
        } else {
          const error = await response.json();
        }
      } catch (error) {
      } finally {
      }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(cents / 100);
    }

    open() {
      document.body.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
      
      this.closeButton = this.querySelector(".quick-add-modal__close")
      if (this.closeButton) {
          this.closeButton.onclick = () => this.close()
      }
    }

    close() {
            this.quantity = 1;
            if (this.quantityValueContainer) {
                this.quantityValueContainer.textContent = this.quantity;
            }

            this.updateQuantityButtonsState?.();

            const sizeButtons = this.querySelectorAll(".quick-add-modal__sizes-item");
            sizeButtons.forEach(button => {
                button.classList.remove("active");
            });

            const colorButtons = this.querySelectorAll(".quick-add-modal__colors-item");
            colorButtons.forEach(button => {
                button.classList.remove("active");
            });
            
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
    }
  });
}

window.openQuickAddModal = async function (event, props) {
    const { product, currentVariant, isVariantCard = false } = props
    const stitchingProductsJSON = document.querySelector(`[data-card-stitching-${product.id}]`)

  const modal = document.querySelector('#QuickAddModal');
  if (modal) {
    modal.renderModalProductData(stitchingProductsJSON, product, currentVariant, isVariantCard)
    modal.open();
  }
};




